import {clearStaticCatalogCache} from '../hooks/useStaticCatalog'

export const parseId = (id: string | number) => {
  if (!id) return 0
  if (typeof id === 'number') return id
  if (Number(id)) return id
  const parse = window.atob(id)
  const idStr = parse.split(':')[1]
  return idStr
}

const COLORS = ['primary', 'success', 'info', 'warning', 'danger', 'dark'] as const
export const getColorMember = (idx: number) => {
  const i = idx % COLORS.length
  return COLORS[i]
}

export const handleUpdateApp = (onLoading: (bool: boolean) => void) => {
  if ('serviceWorker' in window.navigator) {
    clearStaticCatalogCache()
    onLoading(true)
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const registration of registrations) {
        registration.unregister()
      }
      // eslint-disable-next-line no-undef
      caches.keys().then((kl) => {
        kl.forEach((key) => {
          // eslint-disable-next-line no-undef
          caches.delete(key)
        })
        /* NAMES_LOCALSTORAGE.forEach((name) =>
          window.localStorage.removeItem(name)
        ) */
        onLoading(false)
        window.location.reload()
      })
    })
  }
}

export const validateJsonQuote = (objeto: {[key: string]: any}) => {
  // Verificar si todas las propiedades requeridas están presentes y tienen el tipo de dato correcto
  if (
    typeof objeto.queryType !== 'string' ||
    typeof objeto.year !== 'number' ||
    typeof objeto.householdIncome !== 'string' ||
    // typeof objeto.aptcEligible !== 'boolean' ||
    // typeof objeto.hasMec !== 'boolean' ||
    // typeof objeto.dob !== 'string' ||
    // typeof objeto.isPregnant !== 'boolean' ||
    // typeof objeto.isParent !== 'boolean' ||
    // typeof objeto.usesTobacco !== 'boolean' ||
    // typeof objeto.gender !== 'string' ||
    // typeof objeto.hasMarriedCouple !== 'boolean' ||
    typeof objeto.market !== 'string' ||
    typeof objeto.countyfips !== 'string' ||
    typeof objeto.state !== 'string' ||
    typeof objeto.zipCode !== 'string' ||
    typeof objeto.limit !== 'number' ||
    typeof objeto.offset !== 'number' ||
    typeof objeto.order !== 'string' ||
    typeof objeto.utilizationLevel !== 'string' ||
    !Array.isArray(objeto.people)
  ) {
    return false
  }

  return true
}

export const getColorRamdomBoots = (n: number) => {
  const colors = ['primary', 'info', 'warning', 'error', 'secondary']
  return colors[n % colors.length] || 'dark'
}

export const formatDeductionValue = (value: string, type: 'PERCENTAGE' | 'FIXED') => {
  const num = !value || isNaN(Number(value)) ? 0 : Number(value)

  if (type === 'PERCENTAGE') {
    return `${num}%`
  }

  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(num)
}

export const parsePrice = (price: string | number | null | undefined) => {
  const numericValue =
    typeof price === 'number' ? price : price ? Number(price) : 0
  const num =
    typeof numericValue === 'number' && !Number.isNaN(numericValue)
      ? numericValue
      : 0
  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(num)
}

const ADMIN_PERMISSION = 'add_group';

export const isAdministrator = (permissions: string[]) => 
  permissions.includes(ADMIN_PERMISSION);

export const hasPermission = (permissions: string[], permission: string) =>
  isAdministrator(permissions) ||
  permissions.includes(permission) ||
  (permission === 'view_policy' && permissions.includes('view_all_policies'));

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = match[1] ? '+1 ' : ''
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return phoneNumberString
}

export const getNameAvatar = (name: string) => {
  if (!name) return 'NN'

  const arr = name.trim().split(' ')

  if (arr.length === 1) {
    return `${arr[0][0] ?? ''}${arr[0][1] ?? ''}`.toUpperCase()
  }
  if (arr.length === 2) {
    return `${arr[0][0]}${arr[1][0]}`.toUpperCase()
  }
  return `${arr[0][0]}${arr[2][0]}`.toUpperCase()
}

export const calculateAge = (birthdateString: string): number | "" => {
  if (!birthdateString) return ""

  const birthDate = new Date(birthdateString)
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age-- // No ha cumplido años todavía
  }

  return age
}

export const getYearFromEffectiveDate = (effectiveDate?: string | null): number => {
  const fallbackYear = new Date().getFullYear()
  if (!effectiveDate) return fallbackYear

  const trimmed = effectiveDate.trim()
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (isoMatch) {
    const year = Number(isoMatch[1])
    return Number.isNaN(year) ? fallbackYear : year
  }

  const slashMatch = trimmed.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/)
  if (slashMatch) {
    const year = Number(slashMatch[3])
    return Number.isNaN(year) ? fallbackYear : year
  }

  const yearMatch = trimmed.match(/^(\d{4})$/)
  if (yearMatch) {
    const year = Number(yearMatch[1])
    return Number.isNaN(year) ? fallbackYear : year
  }

  const firstFour = Number(trimmed.slice(0, 4))
  return Number.isNaN(firstFour) ? fallbackYear : firstFour
}

export const removeEmptyKeys = (obj: Record<string, any>) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== '' && value !== null && value !== undefined
    )
  )
}


export const removeEmptyKeysDeep = (obj: any): any => {
  if (Array.isArray(obj)) {
    const cleanedArray = obj
      .map(removeEmptyKeysDeep)
      .filter((item) => !(item === null || item === undefined || (typeof item === 'object' && Object.keys(item).length === 0)))
    return cleanedArray.length > 0 ? cleanedArray : undefined
  }

  if (typeof obj === 'object' && obj !== null) {
    const cleanedEntries = Object.entries(obj)
      .map(([key, value]) => [key, removeEmptyKeysDeep(value)])
      .filter(
        ([_, value]) =>
          value !== '' &&
          value !== null &&
          value !== undefined &&
          !(typeof value === 'object' && Object.keys(value).length === 0)
      )

    return cleanedEntries.length > 0 ? Object.fromEntries(cleanedEntries) : undefined
  }

  return obj
}
